import React from 'react'
import ReactDOM from 'react-dom'
// import 'whatwg-fetch'
import 'custom-event-polyfill'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import { USE_NEW_LAYOUT_COOKIE, Y } from '@/constant'
import { getCookie } from '@/utils/common'
// import 'core-js/es'
// import 'core-js/stable/promise'
// import 'core-js/stable/symbol'
// import 'core-js/stable/string/starts-with'
// import 'core-js/web/url'
// import 'core-js/features/array/includes'

import Router from './router/index'
import './index.less'
import { subappConfig } from './index.config'

/**
 * MAIN_APP_NAME 基座标识符
 * metis子应用会用到这个，老项目逻辑迁移
 * getBaseUrl 方便子应用可以动态嵌入任意基座
 */
window.__fetchMainAppParams = () => {
  const isNewLayout = getCookie(USE_NEW_LAYOUT_COOKIE) === Y
  const layoutVersion = isNewLayout ? 'v2' : 'v1'
  const isMix = location.pathname.indexOf('solar/mix') > -1
  const stickyHeadHeight = isNewLayout ? 64 : (isMix ? 0 : 64)

  return {
    MAIN_APP_NAME: 'mendian',
    MAIN_APP_LAYOUT_VERSION: layoutVersion,
    MAIN_APP_LAYOUT_STICKY_HEAD_HEIGHT: stickyHeadHeight,
    getBaseUrl (appName: string) {
      const microApps = subappConfig

      const matchedApp = microApps.filter(app => {
        return app.name === appName
      })

      if (matchedApp.length > 0) {
        return matchedApp[0].entry
      }
      return ''
    }
  }
}

const mainBeidouId = 707

// 忽略的异常
const ignoreErrors = [
  // https://github.com/react-component/align/pull/72#event-3660686845
  'Error:ResizeObserver loop limit exceeded',
  // https://github.com/react-component/align/pull/72#event-3660686845
  'Error:ResizeObserver loop completed with undelivered notifications',
  'Error:Script error',
  'UnhandledRejection:Non-Error',
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1583815
  'Error:AbortError: The operation was aborted.',
  // firefox在页面加载中主动中断页面连接
  'NetworkError when attempting to fetch resource.',
  // firefox在页面加载中主动中断页面连接
  'Error:Request aborted'
]

const getCurrentBeidouId = () => {
  const beidouPidConfig: { [subappName: string]: number } = {
    '/solar/metis': 707,
    '/solar/esf-fe': 707,
    '/solar/zufang': 107,
    '/solar/condo': 256,
    '/solar/mix': 755,
    '/solar/venus': 707,
    '/solar/vip': 129
  }

  const url = location.pathname || ''
  const urlKey = url.match(/^\/solar\/[a-z-]+/)
  if (!(urlKey && urlKey[0])) {
    // 主应用自带页面
    return mainBeidouId
  } else {
    const key = urlKey[0]
    return beidouPidConfig[key] || mainBeidouId
  }
}

window.Beidou &&
  window.Beidou.init({
    projectId: mainBeidouId,
    // isProd: true,
    isProd: process.env.NODE_ENV === 'production',
    isDebug: false,
    ignoreErrors,
    // 上报之前分发流量
    beforeSend: (event: any) => {
      if (event.type === 'breadcrumb') {
        return event
      }
      event.projectId = getCurrentBeidouId()
      // if (event.type && event.type === 'exception') {
      //   console.warn('beidou发现异常，准备上报', event)
      // }
      return event
    }
  })

ReactDOM.render(<Router />, document.getElementById('main-root'))
